import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicSessionWithHostOrganisation } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const getPendingSessions = async ({
  organisationId,
}: {
  organisationId: string;
}): Promise<PublicSessionWithHostOrganisation[]> => {
  const response = await axiosClient.get(
    `/${organisationId}/sessions/pending-sessions`,
  );
  return response.data;
};

export function getPendingSessionsQueryKey({
  organisationId,
}: {
  organisationId: string;
}) {
  return ["sessions", organisationId, "pending"];
}

export function useGetPendingSessions(
  {
    organisationId,
  }: {
    organisationId: string;
  },
  queryOptions?: Partial<
    UseQueryOptions<PublicSessionWithHostOrganisation[], HttpError>
  >,
) {
  return useQuery({
    queryKey: getPendingSessionsQueryKey({
      organisationId,
    }),
    queryFn: () =>
      getPendingSessions({
        organisationId,
      }),
    ...queryOptions,
  });
}
